export default __webpack_public_path__ + "static/media/notif_message.37f478bf.wav";